import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  getFiltersFailure,
  getFiltersSuccess,
  saveFilterFailure,
  saveFilterSuccess,
  deleteFilterFailure,
  deleteFilterSuccess,
  toggleFilterModal,
} from "./actions";
import { GET_FILTERS, SAVE_FILTER, DELETE_FILTER } from "./constants";

export function* saveFilterSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/employee-saved-filter`,
      payload
    );
    yield put(saveFilterSuccess());
    yield put(toggleFilterModal({ open: false }));
  } catch (e) {
    yield put(saveFilterFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while saving filter"));
  }
}

export function* getFiltersSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const query = payload?.location_id
    ? `?location_id=${payload.location_id}`
    : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee-saved-filter${query}`
    );
    yield put(getFiltersSuccess(data));
  } catch (e) {
    yield put(getFiltersFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while getting filters"));
  }
}

export function* deleteFilterSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    yield call(api(token).delete, `/api/employee-saved-filter/${payload.id}`);
    yield put(successAlert("Filter deleted successfully"));
    yield put(deleteFilterSuccess());
    typeof onDelete === "function" && onDelete();
  } catch (e) {
    yield put(deleteFilterFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while deleting filter"));
  }
}
export function* saveFilterFlow() {
  yield takeEvery(SAVE_FILTER, saveFilterSaga);
}

export function* getFiltersFlow() {
  yield takeEvery(GET_FILTERS, getFiltersSaga);
}

export function* deleteFilterFlow() {
  yield takeEvery(DELETE_FILTER, deleteFilterSaga);
}

export default function* RotaFiltersSaga() {
  yield all([saveFilterFlow(), getFiltersFlow(), deleteFilterFlow()]);
}
